// (c) TwistedMinds, Gerry Uytdenhouwen - 3 november 2026

const NAV_MINI_KEY = 'besteller.navMini';

// The storage is passed in so tests can use a fake, and because browsers may block
// storage altogether (private mode, blocked cookies): then the navigation simply starts expanded.
export const readNavMini = (storage) => {
    try {
        return storage.getItem(NAV_MINI_KEY) === 'true';
    } catch (error) {
        return false;
    }
};

export const writeNavMini = (storage, mini) => {
    try {
        storage.setItem(NAV_MINI_KEY, String(mini));
    } catch (error) {
        // Not remembering the choice is harmless.
    }
};
